<script>
  import { debounce } from 'lodash';
  import moment from 'moment';
  import parsePhoneNumber from 'libphonenumber-js';
  import rules from '@/helpers/validation-rules';

  import BannerContainer from '@/views/app/dashboard/account/components/BanerContainer.vue';
  import DateOfBirthSelector from '@/components/form/DateOfBirthSelector2.vue';
  import YellowButton from '@/components/base/YellowButton.vue';
  import IconDollar from '@/assets/images/svg/icon-dollar.svg';
  import IconQcCoin from '@/assets/images/svg/icon-qc-coin.svg';

  export default {
    name: 'UserProfile',

    components: {
      YellowButton,
      BannerContainer,
      DateOfBirthSelector,
      IconDollar,
      IconQcCoin,
    },

    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Profile',
    },

    data: () => ({
      rules,
      updateData: {},
      emptyColorFill: {
        radial: true,
        colors: [
          {
            color: '#ce952e',
            offset: '50',
            opacity: '0.2',
          },
          {
            color: '#ce952e',
            offset: '50',
            opacity: '0.15',
          },
          {
            color: '#ce952e',
            offset: '70',
            opacity: '0.15',
          },
          {
            color: '#ce952e',
            offset: '70',
            opacity: '0.1',
          },
          {
            color: '#ce952e',
            offset: '90',
            opacity: '0.1',
          },
          {
            color: 'transparent',
            offset: '90',
            opacity: '0.1',
          },
          {
            color: 'transparent',
            offset: '95',
            opacity: '0.1',
          },
          {
            color: 'transparent',
            offset: '95',
            opacity: '0.1',
          },
        ],
      },
      states: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        // 'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'West Virginia',
        'Wisconsin',
        'Wyoming',
      ],
      progdata: [
        {
          progress: 50, // required for each circle
          color: '#ce952e', // will overwrite global progress color
        },
      ],
      gradient: {
        radial: false,
        colors: [
          {
            color: '#ce952e',
            offset: 0,
            opacity: '1',
          },
          {
            color: 'black',
            offset: 100,
            opacity: '0.6',
          },
        ],
      },

      model: {
        name: '',
        birthday: null,
        countryInfo: {},
        receiveEmails: '',
        receiveSms: '',
      },

      passwords: {
        currentPassword: '',
        newPass: '',
        newPassConfirm: '',
      },

      visiblePasswords: {
        password: false,
        newPassword: false,
        confirmNewPassword: false,
      },

      readonly: {
        name: true,
        address: true,
        dateofbirth: true,
        phoneNumber: true,
        state: true,
      },

      showUpdateProfile: false,
      updateButtonDisabled: true,

      isFormValid: false,

      name: 'PLAYER 1',
      sitecontactnumber: '',
      dateofbirth: '',
      displayName: 'Username',
      loading: false,
      showProfileHint: false,
      profileHintPosition: {
        top: null,
        left: null,
      },
      countryState: '',
      activeContainer: 'profile-container',
      isValidPhone: false,
      errMessage: null,

      referralEarnings: 0,
    }),

    computed: {
      balance() {
        return this.$store.getters.getFormattedBalance;
      },

      isUserSuspended() {
        return this.$store.getters.isUserSuspended;
      },
      // getActiveBonuses() {
      //   let allBonuses = this.$store.getters.getBonusHistory;
      //   allBonuses = allBonuses.filter(function (bonus) {
      //     return bonus.status.toUpperCase() === 'ACTIVE';
      //   });
      //   return allBonuses;
      // },
      passwordsAreEqual() {
        return this.passwords.newPass === this.passwords.newPassConfirm || 'Password doesn’t match!';
      },

      sidebarIsOpened() {
        return !this.$store.getters.getSideBarState;
      },
    },

    watch: {
      '$vuetify.breakpoint.mdAndDown': {
        immediate: true,
        handler() {
          this.showProfileHint = this.$vuetify.breakpoint.mdAndDown;
        },
      },
    },

    async mounted() {
      await this.$store.dispatch('getPlayerInfo');

      this.$nextTick(() => {
        this.initLoad();
      });
    },

    created() {
      let user = this.$store.getters.getuser;
      if (user && user.balance) {
        this.refreshBalance();
      }
      // this.$store.dispatch('getBonusHistory');
    },

    methods: {
      async initLoad() {
        this.loading = true;

        const details = await this.$store.getters.getPlayerInfo.profile;

        if (details) {
          this.showUpdateProfile = false;
          this.updateButtonDisabled = true;

          if (details.firstname) {
            details.name = `${details.firstname}`;
          }
          if (details.lastname) {
            details.name = `${details.firstname} ${details.lastname}`;
          }

          if (details.dateofbirth) {
            const birthDate = moment(details.dateofbirth, 'YYYY-M-D');

            details.birthday = {
              day: birthDate.format('D'),
              month: birthDate.format('M'),
              year: birthDate.format('YYYY'),
            };
          }

          if (!details.firstname) {
            this.readonly.name = false;
            this.showUpdateProfile = true;
          } else {
            this.readonly.name = true;
          }
          if (!details.address) {
            this.readonly.address = false;
            this.showUpdateProfile = true;
          } else {
            details.newAddress = details.address;
            this.readonly.address = true;
          }
          if (!details.state) {
            this.readonly.state = false;
            this.showUpdateProfile = true;
          } else {
            details.newState = details.state.name;
            this.readonly.state = true;
          }
          if (!details.dateofbirth) {
            this.readonly.dateofbirth = false;
            this.showUpdateProfile = true;
          } else {
            this.readonly.dateofbirth = true;
          }
          if (!details.phoneNumber) {
            details.newPhone = '';
            this.readonly.phoneNumber = false;
            this.showUpdateProfile = true;
          } else {
            details.newPhone = details.phoneNumber;
            this.readonly.phoneNumber = true;
          }

          this.displayName = details.displayName;

          this.countryState = details.countryInfo?.countryName;

          if (details.countryInfo?.stateCode && details.countryInfo?.countryCode === 'US') {
            this.countryState = `${details.countryInfo.countryName}, ${details.countryInfo.stateCode}`;
          }
          if (!details.receiveEmails) {
            this.model.receiveEmails = false;
          }
          if (!details.receiveSms) {
            this.model.receiveSms = false;
          }
        }

        this.model = {
          ...this.model,
          ...details,
        };

        const earnings = await this.$store.dispatch('getMyTotalReferralRewards');

        if (earnings) {
          this.referralEarnings = Number((earnings / 100).toLocaleString()).toFixed(2);
        }

        this.loading = false;
      },

      refreshBalance() {
        let user = this.$store.getters.getuser;

        if (user && user.balance) {
          this.$store.dispatch('getUserBalance');
        }
      },

      checkPhoneNumber() {
        if (this.model.newPhone.length > 1) {
          const check = parsePhoneNumber(this.model.newPhone, this.model.countryInfo.countryCode);
          this.isValidPhone = check?.isValid() || false;
        }
        if (this.isValidPhone) {
          const validation = /^[0-9]*$/;
          this.isValidPhone = validation.test(this.model.newPhone);
        }

        if (!this.isValidPhone) {
          if (this.model.newPhone.length > 0) {
            this.errMessage = ['Invalid phone number'];
          } else {
            this.errMessage = [];
          }
        } else {
          this.errMessage = [];
        }
      },
      setActiveContainer(item) {
        this.activeContainer = item;
      },
      async updateProfile() {
        const birthDate = this.$refs.dateOfBirth.getDate();

        if (!this.readonly.name && this.model.name) {
          const name = this.model.name.trim().split(' ');
          try {
            this.updateData.firstname = name[0];
            this.updateData.lastname = name.slice(1).join(' ');
          } catch {
            this.updateData.firstname = this.model.name;
            this.updateData.lastname = '';
          }
        }
        if (!this.readonly.address && this.model.newAddress) {
          this.updateData.address = this.model.newAddress;
        }
        if (!this.readonly.state && this.model.newState) {
          this.updateData.state = this.model.newState;
        }
        if (!this.readonly.dateofbirth && birthDate) {
          this.updateData.dateofbirth = birthDate;
        }
        if (!this.readonly.phoneNumber && this.model.newPhone && this.isValidPhone) {
          this.updateData.phoneNumber = this.model.newPhone;
        }
        this.updateData.receiveEmails = this.model.receiveEmails;
        this.updateData.receiveSms = this.model.receiveSms;

        if (Object.keys(this.updateData).length > 0) {
          await this.$store.dispatch('updateUserProfile', this.updateData);
          await this.$store.dispatch('getPlayerInfo');
          this.updateData = {};

          await this.initLoad();
        }
      },
      submitChangePasswordForm() {
        if (!this.$refs['password-form'].validate()) {
          return;
        }

        this.$store.dispatch('showConfirmDialog', {
          title: 'Change Password',
          text: 'Are you sure you want to change your password?',
          callback: async () => {
            await this.updateCurrentPassword();
          },
        });
      },
      async updateCurrentPassword() {
        await this.$store.dispatch('updateCurrentPassword', this.passwords);

        this.$refs['password-form'].reset();
      },
      suspendAccount() {
        this.$store.dispatch('suspendAccount');
      },
      changeProfileHintState(value) {
        if (this.$vuetify.breakpoint.mdAndDown) {
          return;
        }

        this.showProfileHint = value;
      },
      setHintPosition(event) {
        const element = this.$refs.hintArea;
        const hintArea = element.getBoundingClientRect();

        this.profileHintPosition.top = event.clientY - hintArea.top + 'px';
        this.profileHintPosition.left = event.clientX - hintArea.left + 'px';
      },
      updateHintPosition: debounce(function (event) {
        if (this.$vuetify.breakpoint.mdAndDown) {
          return;
        }

        this.setHintPosition(event);
      }, 100),
      enableUpdateButton() {
        this.updateButtonDisabled = false;
      },
      enableUpdateButton2(event) {
        if (event && !this.readonly.dateofbirth) {
          this.enableUpdateButton();
        }
      },
      togglePasswordVisibility(key) {
        this.visiblePasswords[key] = !this.visiblePasswords[key];
      },
    },
  };
</script>

<template>
  <div class="detailbglight pvp-lg h-100 d-grid">
    <div v-if="loading" class="d-grid justify-items-center align-center">
      <vue-ellipse-progress
        :data="progdata"
        :empty-color-fill="emptyColorFill"
        :empty-thickness="3"
        :gradient="gradient"
        :legend="false"
        :loading="true"
        :progress="100"
        :size="350"
        :thickness="7"
        animation="rs 700 1000"
        dash="strict 60 0.8"
        empty-color="grey"
        font-size="1.5rem"
        line-mode="out 5"
      >
        <template #legend-caption>
          <v-icon color="#F8BF1E" size="46">mdi-sword-cross</v-icon>
        </template>
      </vue-ellipse-progress>
    </div>
    <template v-else>
      <section class="profile-header mx-2 mx-sm-5 mx-lg-10 mt-sm-3">
        <div class="profile-header-wrapper" style="flex: 1">
          <div class="profile-header-container">
            <div class="user-avatar-col d-flex flex-column align-center justify-center">
              <div class="user-image-wrapper position-relative">
                <div class="user-image-container">
                  <div class="text-subtitle-1 text-sm-h6 semi gold--text semi">
                    <div class="user-name text-center superbold">
                      {{ displayName }}
                    </div>
                  </div>
                  <div class="d-flex align-center justify-center">
                    <v-img
                      v-reload-on-fail
                      class="user-image"
                      cover
                      max-width="194"
                      min-width="95"
                      src="/images/icons/avatar-user.png"
                    />
                  </div>
                </div>
              </div>
            </div>
            <banner-container
              class="py-0 py-sm-2 px-4"
              class-name="user-balance-col w-full"
              image-src="/images/icons/icon_safe.png"
              title="Balance"
            >
              <div class="d-flex align-center justify-end">
                <IconQcCoin class="balance-image" />
                <div class="balance-container ml-2">
                  <span class="text-subtitle-1 text-sm-h6 semi">
                    {{ balance.mqc }}
                  </span>
                </div>
              </div>
              <div class="d-flex align-center justify-end">
                <IconDollar class="balance-image" />
                <div class="balance-container ml-2">
                  <span class="text-subtitle-1 text-sm-h6 semi">
                    {{ balance.mmc }}
                  </span>
                </div>
              </div>
            </banner-container>
            <banner-container
              class="py-0 py-sm-2 px-4 mt-5 mt-sm-3 mt-md-0"
              class-name="user-refer-col"
              image-src="/images/icons/ICON_referFriends.png"
              title="Refer Friends"
            >
              <p class="text-h6 text-xl-h5 semi white--text text-right mt-1 mb-1">YOUR EARNINGS</p>
              <div class="d-flex align-center justify-end">
                <IconDollar class="balance-image" />
                <div class="balance-container ml-2">
                  <span class="text-subtitle-1 text-sm-h6 semi">
                    {{ referralEarnings }}
                  </span>
                </div>
              </div>
            </banner-container>
          </div>
        </div>
      </section>

      <v-row class="profile-content pb-15 mx-8 mx-md-10">
        <!--  Profile -->
        <v-col
          :class="{
            active: activeContainer === 'profile-container',
          }"
          class="profile-container profile-col pa-0 pr-10 mb-lg-0 pt-5 pt-sm-10"
          cols="12"
          lg="6"
          @mouseover="setActiveContainer('profile-container')"
        >
          <div class="profile-text gold--text text-h6 text-sm-h5 bold mb-3 ml-7">Profile</div>

          <div class="d-flex flex-column justify-space-between" style="height: calc(100% - 52px)">
            <v-form
              v-model="isFormValid"
              :disabled="isUserSuspended"
              class="px-4"
              lazy-validation
              style="height: min-content"
            >
              <v-row class="position-relative">
                <v-row ref="hintArea" class="profile-info-container">
                  <template v-if="$vuetify.breakpoint.lgAndUp">
                    <v-col
                      :class="readonly.name ? 'field-readonly' : ''"
                      class="pb-0 pt-0 pt-sm-3"
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <div class="profile-input-title">Name</div>
                      <v-text-field
                        v-model="model.name"
                        :readonly="readonly.name"
                        :rules="[rules.maxLength(255), rules.onlyLetters(), rules.noOnlySpaces()]"
                        autocomplete="null"
                        persistent-placeholder
                        placeholder="First Name Last Name"
                        solo
                        @input="enableUpdateButton"
                      />
                    </v-col>
                    <v-col
                      :class="readonly.dateofbirth ? 'field-readonly' : ''"
                      class="pb-0"
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <div class="profile-input-title">Date Of Birth</div>
                      <date-of-birth-selector
                        ref="dateOfBirth"
                        :activeRules="!readonly.dateofbirth"
                        :dayValue="model.birthday && parseInt(model.birthday.day)"
                        :monthValue="model.birthday && parseInt(model.birthday.month)"
                        :readonly="readonly.dateofbirth"
                        :yearValue="model.birthday && parseInt(model.birthday.year)"
                        @update="enableUpdateButton2($event)"
                      />
                    </v-col>
                    <v-col class="pb-0 field-readonly" cols="12" lg="6" md="6" sm="12">
                      <div class="profile-input-title">E-mail</div>
                      <v-text-field v-model="model.email" hide-details readonly solo />
                    </v-col>
                    <v-col
                      :class="readonly.address ? 'field-readonly' : ''"
                      class="pb-0"
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <div class="profile-input-title">Address</div>
                      <v-text-field
                        v-model="model.newAddress"
                        :readonly="readonly.address"
                        :rules="[rules.onlyLettersAndNumbers(), rules.noOnlySpaces()]"
                        autocomplete="null"
                        placeholder="Address"
                        solo
                        @input="enableUpdateButton"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6" sm="12">
                      <div class="profile-input-title">Country / State</div>
                      <div class="d-flex countryStateWrapper">
                        <div class="field w-30" style="opacity: 0.5">
                          <v-text-field hide-details readonly solo value="USA" @input="enableUpdateButton" />
                        </div>
                        <div class="field-container position-relative w-full">
                          <div class="field1 w-full countryField ml-1">
                            <v-text-field
                              v-model="model.newState"
                              attach=".field-container"
                              disabled
                              placeholder="State"
                              readonly
                              solo
                            />
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col
                      :class="readonly.name ? 'field-readonly' : ''"
                      class="pb-0 pt-0 pt-sm-3"
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <div class="profile-input-title">Name</div>
                      <v-text-field
                        v-model="model.name"
                        :readonly="readonly.name"
                        :rules="[rules.maxLength(255), rules.onlyLetters(), rules.noOnlySpaces()]"
                        autocomplete="null"
                        persistent-placeholder
                        placeholder="First Name Last Name"
                        solo
                        @input="enableUpdateButton"
                      />
                    </v-col>
                    <v-col class="pb-0 field-readonly" cols="12" lg="6" md="6" sm="12">
                      <div class="profile-input-title">E-mail</div>
                      <v-text-field v-model="model.email" readonly solo />
                    </v-col>
                    <v-col
                      :class="readonly.address ? 'field-readonly' : ''"
                      class="pb-0"
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <div class="profile-input-title">Address</div>
                      <v-text-field
                        v-model="model.newAddress"
                        :readonly="readonly.address"
                        :rules="[rules.onlyLettersAndNumbers(), rules.noOnlySpaces()]"
                        placeholder="Address"
                        @input="enableUpdateButton"
                      />
                    </v-col>
                    <v-col
                      :class="readonly.dateofbirth ? 'field-readonly' : ''"
                      class="pb-0"
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <div class="profile-input-title">Date Of Birth</div>
                      <date-of-birth-selector
                        ref="dateOfBirth"
                        :activeRules="!readonly.dateofbirth"
                        :dayValue="model.birthday && parseInt(model.birthday.day)"
                        :monthValue="model.birthday && parseInt(model.birthday.month)"
                        :readonly="readonly.dateofbirth"
                        :yearValue="model.birthday && parseInt(model.birthday.year)"
                        @update="enableUpdateButton2($event)"
                      />
                    </v-col>

                    <!--                    <v-col-->
                    <!--                      cols="12"-->
                    <!--                      sm="12"-->
                    <!--                      md="6"-->
                    <!--                      lg="6"-->
                    <!--                      class="pb-0 elevation-0"-->
                    <!--                      :class="readonly.phoneNumber ? 'field-readonly' : ''"-->
                    <!--                    >-->
                    <!--                      <div class="profile-input-title">Phone</div>-->
                    <!--                      <v-row class="px-3" style="position: relative">-->
                    <!--                        <v-col cols="3" class="pa-0">-->
                    <!--                          <div class="flagImage">-->
                    <!--                            <v-img v-reload-on-fail-->
                    <!--                              v-if="-->
                    <!--                                model.countryInfo &&-->
                    <!--                                model.countryInfo.countryFlag-->
                    <!--                              "-->
                    <!--                              :src="model.countryInfo.countryFlag"-->
                    <!--                            />-->
                    <!--                          </div>-->
                    <!--                          <v-text-field-->
                    <!--                            v-model="model.countryInfo.phoneCountryCode"-->
                    <!--                            solo-->
                    <!--                            hide-details-->
                    <!--                            class="inputPhoneCode elevation-0"-->
                    <!--                            readonly-->
                    <!--                          />-->
                    <!--                        </v-col>-->
                    <!--                        <v-col cols="9" class="pa-0">-->
                    <!--                          <v-text-field-->
                    <!--                            ref="phoneNumberInput"-->
                    <!--                            v-model="model.newPhone"-->
                    <!--                            placeholder="Phone number"-->
                    <!--                            :error-messages="errorMessages"-->
                    <!--                            :rules="[rules.onlyNumbers()]"-->
                    <!--                            @input="-->
                    <!--                              checkPhoneNumber();-->
                    <!--                              enableUpdateButton();-->
                    <!--                            "-->
                    <!--                            solo-->
                    <!--                            :readonly="readonly.phoneNumber"-->
                    <!--                            class="inputPhoneNumber w-full elevation-0 pl-1"-->
                    <!--                            autocomplete="null"-->
                    <!--                          />-->
                    <!--                        </v-col>-->
                    <!--                      </v-row>-->
                    <!--                    </v-col>-->
                    <v-col class="pb-0" cols="12" md="6" sm="12">
                      <div class="profile-input-title">Country / State</div>
                      <div class="d-flex countryStateWrapper">
                        <div class="field w-30" style="opacity: 0.5">
                          <v-text-field hide-details readonly solo value="USA" @input="enableUpdateButton" />
                        </div>
                        <div class="field-container position-relative w-full">
                          <div class="field1 w-full countryField ml-1">
                            <v-text-field
                              v-model="model.newState"
                              append-icon="mdi-chevron-down"
                              attach=".field-container"
                              disabled
                              placeholder="State"
                              readonly
                              solo
                            />
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </template>

                  <v-col class="pb-0 mt-3 mt-md-7 mt-lg-0" cols="12">
                    <v-checkbox
                      v-model="model.receiveSms"
                      :disabled="isUserSuspended"
                      class="ma-0 whiteCheckbox"
                      color="yellow"
                      dark
                      hide-details
                      off-icon="mdi-checkbox-blank"
                      @click="enableUpdateButton"
                    >
                      <template v-slot:label>
                        <div class="white--text text-h6 font-weight-400">
                          I agree to receive exclusive updates, promotions, and news about MaxQuest via SMS.
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col class="pt-2 pt-sm-0 pb-0" cols="12">
                    <v-checkbox
                      v-model="model.receiveEmails"
                      :disabled="isUserSuspended"
                      class="ma-0 whiteCheckbox"
                      color="yellow"
                      dark
                      hide-details
                      off-icon="mdi-checkbox-blank"
                      @click="enableUpdateButton"
                    >
                      <template v-slot:label>
                        <div class="white--text text-h6 font-weight-400">
                          I agree to receive exclusive updates, promotions, and news about MaxQuest via EMAIL.
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-fade-transition>
                  <v-card
                    v-if="false"
                    :class="{
                      centered: $vuetify.breakpoint.mdAndDown,
                    }"
                    :style="profileHintPosition"
                    class="profile-hint"
                  >
                    In order to make changes over this part of your profile, please get in touch with our support team
                    or contact us at:
                    <strong>helpdesk@maxquest.com</strong>
                  </v-card>
                </v-fade-transition>
              </v-row>
            </v-form>
            <div class="d-flex justify-center justify-lg-start my-2 my-sm-5 my-lg-0 update-profile-button">
              <action-button>
                <template #action="{ loading, clickHandler }">
                  <YellowButton
                    class="update-button"
                    :disabled="updateButtonDisabled || !isFormValid || isUserSuspended"
                    :loading="loading"
                    @click="clickHandler(updateProfile)"
                  >
                    UPDATE PROFILE
                  </YellowButton>
                </template>
              </action-button>
            </div>
          </div>
        </v-col>

        <v-divider class="image-divider" vertical />
        <div class="divider-m mt-6 mb-sm-4">
          <div class="inside" />
        </div>

        <!--    Password    -->
        <v-col
          :class="{
            active: activeContainer === 'password-container',
          }"
          class="password-container password-col d-flex flex-column pt-10 pb-lg-1 px-0 px-sm-3 px-md-5 px-xl-7 mb-7 mb-lg-0"
          cols="12"
          lg="3"
          @mouseover="setActiveContainer('password-container')"
        >
          <div class="password-text gold--text text-md-center text-h6 text-sm-h5 bold mb-3 ml-7">Change Password</div>

          <div class="d-flex flex-column justify-space-between px-4">
            <v-form
              ref="password-form"
              :disabled="isUserSuspended"
              lazy-validation
              style="min-height: min-content"
              @submit.prevent="submitChangePasswordForm"
            >
              <v-row>
                <v-col class="pb-0" cols="12">
                  <div class="profile-input-title">Current password</div>
                  <v-text-field
                    ref="currentPass"
                    v-model="passwords.currentPassword"
                    :append-icon="visiblePasswords.password ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required(), rules.minLength(6)]"
                    :type="visiblePasswords.password ? 'text' : 'password'"
                    solo
                    @click:append="togglePasswordVisibility('password')"
                  />
                </v-col>
                <v-col class="pb-0" cols="12">
                  <div class="profile-input-title">New password</div>
                  <v-text-field
                    ref="newPass"
                    v-model="passwords.newPass"
                    :append-icon="visiblePasswords.newPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :class="{ 'password-hint--with-sidebar': sidebarIsOpened }"
                    :rules="[rules.required(), rules.minLength(6), rules.maxLength(32), rules.password()]"
                    :type="visiblePasswords.newPassword ? 'text' : 'password'"
                    class="hinted"
                    hint="Password must be 6-32 characters long, with at least 1 letter and 1 number"
                    persistent-hint
                    solo
                    @click:append="togglePasswordVisibility('newPassword')"
                  />
                </v-col>
                <v-col class="pb-0 mt-5" cols="12">
                  <div class="profile-input-title">Confirm New Password</div>
                  <v-text-field
                    ref="newPassConfirm"
                    v-model="passwords.newPassConfirm"
                    :append-icon="visiblePasswords.confirmNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required(), passwordsAreEqual]"
                    :type="visiblePasswords.confirmNewPassword ? 'text' : 'password'"
                    solo
                    @click:append="togglePasswordVisibility('confirmNewPassword')"
                  />
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="save-button d-flex justify-center align-md-end h-100 my-2 my-sm-5 my-lg-0">
            <action-button>
              <template #action="{ loading }">
                <YellowButton
                  :disabled="isUserSuspended"
                  :loading="loading"
                  @click="submitChangePasswordForm"
                  class="save-password-button"
                >
                  SAVE NEW PASSWORD
                </YellowButton>
              </template>
            </action-button>
          </div>
        </v-col>
        <div class="divider-m mt-6 mb-sm-4">
          <div class="inside" />
        </div>

        <div
          :class="{
            active: activeContainer === 'password-container',
          }"
          @mouseover="setActiveContainer('profile-container')"
        />
        <v-divider class="image-divider" vertical />

        <!--    Quests    -->
        <v-col
          class="quests-col d-flex flex-column pa-0 pt-lg-10 mt-7 mt-lg-0 px-0 px-sm-3 px-md-5 px-xl-7"
          cols="12"
          lg="3"
        >
          <div class="quests-text gold--text text-h6 text-sm-h5 bold mb-3 ml-7">Quests</div>
          <div class="mt-md-10">
            <v-img
              v-reload-on-fail
              class="ma-auto quests-image"
              cover
              max-width="400"
              min-width="220"
              src="/images/icons/Quests_Image.png"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .tabTitle {
    z-index: 2 !important;
  }

  .field::v-deep {
    .v-input {
      .v-input__control {
        .v-input__slot {
          padding: 8px !important;
        }
      }
    }
  }

  .countryField::v-deep {
    opacity: 0.5;

    .v-input {
      i {
        display: none;
      }
    }
  }

  .profile-header-wrapper {
    container-name: profileHeader;
    container-type: inline-size;

    @container profileHeader (min-width: 200px) and (max-width: 559px) {
      .profile-header-container {
        display: flex;
        flex-direction: column;
      }
    }

    @container profileHeader (min-width: 560px) and (max-width: 800px) {
      .profile-header-container {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        flex-direction: row;
      }

      .user-balance-col {
        width: calc(100% - 160px);
      }

      .user-refer-col {
        flex-grow: 1;
      }

      .user-image-wrapper {
        max-width: 160px;
      }
    }

    @container profileHeader (min-width: 801px) and (max-width: 1199px) {
      .profile-header-container {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        flex-direction: row;
      }

      .user-balance-col {
        width: calc(100% - 194px);
      }

      .user-refer-col {
        flex-grow: 1;
      }
    }

    @container profileHeader (min-width: 1200px) {
      .profile-header-container {
        display: grid;
        grid-template-columns: 200px repeat(auto-fit, minmax(400px, 1fr));
      }
    }

    @container profileHeader (min-width: 1263px) {
      grid-template-columns: 200px repeat(auto-fit, minmax(30%, 1fr));
    }
  }

  .profile-content {
    container-name: profileContent;
    container-type: inline-size;

    @container profileContent (width < 1264px) {
      .col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }

      .countryField {
        .v-input {
          .v-input__control {
            .v-input__slot {
              .v-text-field__slot {
                input {
                  margin-left: 2vw;
                }
              }
            }
          }
        }
      }

      .password-col,
      .profile-col,
      .quests-col {
        padding-right: 0 !important;
        z-index: 2;
      }

      .password-text {
        margin-left: 0 !important;
      }

      .quests-col {
        padding-top: 0 !important;
      }

      .save-button {
        margin: 0 auto 50px auto;
      }

      .update-profile-button {
        margin: 0 auto;
      }

      button.greenBtn {
        min-width: 100px !important;
        height: 44px !important;
        border-radius: 30px !important;
        width: 100% !important;
      }

      button.greenBtn.double-border::after {
        border: 2px solid #72b619 !important;
      }

      button.purpleBtn.double-border::after {
        border: 2px solid #8979b8 !important;
        top: -6px;
        bottom: -6px;
        left: -6px;
        right: -6px;
      }

      button.purpleBtn {
        border: 2px solid #8979b8 !important;
        min-width: 240px !important;
        font-size: 24px !important;
        height: 44px !important;
        color: #fff;
        padding: 2px;
        border-radius: 30px;
        font-weight: 700;
      }

      .quests-text,
      .password-text,
      .profile-text {
        border-bottom: 1px solid #f8bf1e;
        padding-bottom: 10px;
      }

      .image-divider {
        display: none !important;
      }

      .divider-m {
        position: relative;
        flex: 0 0 100%;
        max-width: 90%;
        left: 5%;
        height: 6px;
        border-radius: 10px;
        z-index: 0;

        .inside {
          position: absolute;
          background-image: url('/images/figures/Friends-divider.png');
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          left: -15%;
          top: -50px;
          width: 130%;
          height: 100px;
          overflow: hidden;
        }
      }
    }
  }

  .profile-header-container {
    display: grid;
  }

  .user-image-wrapper {
    min-width: 150px;
    height: 194px;

    .user-image-container {
      filter: drop-shadow(0 0 12px #ffc713);

      .user-name {
        position: relative;
        top: 5px;
      }
    }
  }

  .balance-container {
    width: max-content;
    background: #151518;
    border-radius: 10px;
    box-shadow:
      0 0 10px var(--v-main-lighter-base),
      inset 0 0 10px #000000;
    padding: 8px 8px 8px 28px;
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 8px;
  }

  .profile-header::v-deep {
    display: flex;

    .user-image-col {
      display: none;
    }
  }

  .profile-info-container {
    position: relative;

    &::v-deep .v-text-field .v-input__slot {
      background: #fff;

      &::before,
      &::after {
        border: 0;
      }
    }
  }

  .profile-hint {
    position: relative;
    color: white;
    width: 100%;
    max-width: 500px;
    padding: 15px 25px;
    font-style: italic;
    background: linear-gradient(90deg, #8579b4, #48305c);
    border-radius: 10px;
    transition: all 0.3s ease;
    z-index: 1;
    opacity: 1;
    pointer-events: none;
    margin: auto;
  }

  .field:first-child::v-deep {
    .v-input__slot {
      border-radius: 10px 0 0 10px !important;
    }
  }

  .field:last-child::v-deep {
    .v-input__slot {
      border-radius: 0 10px 10px 0 !important;
    }
  }

  .pvp-lg::v-deep {
    .v-input.inputPhoneCode:not(.v-input--checkbox) {
      .v-input__control {
        .v-input__slot input {
          padding-left: 26px !important;
          padding-right: 0 !important;

          &:before {
            content: '+';
          }
        }
      }
    }
  }

  .v-input.inputPhoneCode::v-deep {
    .v-input__slot {
      border-radius: 10px 0 0 10px !important;
      box-shadow: none !important;
    }
  }

  .v-input.inputPhoneNumber::v-deep {
    .v-input__slot {
      border-radius: 0 10px 10px 0 !important;
      box-shadow: none !important;
    }
  }

  .field:first-child {
    margin-right: -4%;
    clip-path: polygon(0 1%, 100% 0%, 83% 100%, 0% 100%);
  }

  .field1 {
    clip-path: polygon(5% 0, 100% 0%, 100% 100%, 0 100%);
  }

  .field-readonly {
    position: relative;
  }

  .field-readonly > div,
  .field-readonly > form {
    opacity: 0.5;
  }

  .field-readonly:hover::after {
    content: 'In order to make changes over this part of your profile, please get in touch with our support team or contact us at: helpdesk@maxquest.com';
    position: absolute;
    display: flex;
    text-align: center;
    align-items: center;
    top: 50%;
    right: 0;
    width: 90%;
    max-width: 400px;
    background: linear-gradient(90deg, #8579b4, #48305c);
    color: #fff;
    z-index: 1000;
    padding: 8px 16px;
    opacity: 1;
    border-radius: 8px;
  }

  .profile-input-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: white;
    padding-left: 24px;
    margin-bottom: 8px;
  }

  .image-divider {
    background-color: transparent !important;
    border-color: transparent !important;
    background-image: url('/images/PasswordDivider.png');
    background-position: center center;
    background-size: cover;
    height: 40%;
    filter: blur(0.6px);
    min-height: auto;
    max-width: 100%;
    margin-top: 100px !important;
    display: inline-flex;
  }

  .date-of-birth-wrapper {
    gap: 5px;
  }

  .v-subheader {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    padding-left: 10px !important;
  }

  .inset_color {
    color: #332e3f;
    background-color: rgba(51, 46, 63, 1);
  }

  .detailbglight {
    display: flex !important;
    flex-direction: column;
  }

  .detailbglight > div {
    flex: 0 1 auto;
  }

  .flagImage {
    position: absolute;
    top: 16px;
    left: 24px;
    width: 14px;
    z-index: 100;
    bottom: 24px;
  }

  .flagImage img {
    width: 20px;
  }

  .balance-image {
    width: 100%;
    height: 100%;
    max-width: 30px;

    @media screen and (max-width: 600px) {
      max-width: 24px;
    }
  }

  @media screen and (max-width: 1919px) {
    .pvp-lg::v-deep {
      .v-input:not(.yearInput):not(.v-input--checkbox) {
        .v-input__control {
          .v-input__slot {
            input,
            textarea {
              font-size: 1rem !important;
              padding: 0 8px 4px !important;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .pvp-lg::v-deep {
      .v-input:not(.v-input--checkbox) {
        .v-input__control {
          .v-input__slot {
            padding: 0 4px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1264px) and (max-width: 1500px) {
    .profile-header {
      display: block;
    }

    .profile-input-title {
      font-size: 1rem !important;
    }
  }

  @media screen and (max-width: 1000px) {
    .password-col,
    .profile-col,
    .quests-col {
      max-width: 100%;
    }

    .greenBtn.double-border {
      width: initial !important;
      min-width: 150px !important;
    }
  }

  @media screen and (max-width: 960px) {
    .user-image-wrapper {
      height: 160px !important;

      .user-image-container {
        .user-image {
          max-width: 160px !important;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .balance-container {
      padding: 4px 8px 4px 28px;
      margin-top: 4px;
      margin-bottom: 4px;
      margin-right: 8px;
    }
  }

  @media screen and (max-width: 600px) {
    .no-wrap {
      white-space: nowrap !important;
    }

    .user-image-wrapper {
      height: 140px !important;

      .user-image-container {
        .user-image {
          max-width: 139px !important;
        }
      }
    }

    .user-balance-col {
      margin-top: 6px !important;
    }

    .greenBtn.double-border.buttonInside {
      width: initial !important;
      min-width: 150px !important;
      height: 36px !important;
      font-size: 16px !important;
    }

    button.greenBtn {
      height: 36px !important;
    }

    button.purpleBtn {
      background-color: transparent !important;
      font-size: 16px !important;
      height: 36px !important;
      min-width: 150px !important;
    }

    .profile-input-title {
      font-size: 1rem;
    }

    .pvp-lg::v-deep {
      .flagImage {
        left: 20px;
      }

      .v-input.inputPhoneCode:not(.v-input--checkbox) {
        .v-input__control {
          .v-input__slot input {
            padding-left: 20px !important;
          }
        }
      }
    }

    .flagImage {
      top: 12px;
    }
  }

  @media screen and (max-width: 460px) {
    .user-image-wrapper {
      height: 140px !important;

      .user-image-container {
        .user-name {
          top: 3px !important;
        }

        .user-image {
          max-width: 130px !important;
        }
      }
    }
  }

  @media screen and (max-width: 360px) {
    .user-img {
      max-width: 130px !important;
      bottom: 0;
    }
  }

  @media screen and (max-width: 400px) {
    .pvp-lg::v-deep {
      .v-input:not(.v-input--checkbox) {
        .v-input__control {
          .v-input__slot {
            padding: 0 4px;

            input,
            textarea {
              padding: 0 0 4px !important;
            }
          }
        }
      }
    }
  }

  .password-hint--with-sidebar {
    &::v-deep {
      .v-messages__message {
        @media screen and (min-width: 1264px) {
          padding: 0;
          font-size: 11px;
        }

        @media screen and (min-width: 1440px) {
          font-size: 12px;
        }

        @media screen and (min-width: 1600px) {
          font-size: 14px;
        }
      }
    }
  }

  .update-profile-button,
  .update-profile-button > div,
  .save-button,
  .save-button > div {
    @media screen and (max-width: 767px) {
      width: 100%;
      padding-inline: 8px;
    }
  }

  .update-button {
    margin-top: 24px;
  }

  .update-button,
  .save-password-button {
    height: 48px;
    font-size: 16px;
    font-weight: 800;
    width: 100%;

    @media screen and (min-width: 768px) {
      padding-inline: 32px;
    }
  }
</style>
